import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { ScaledSheet } from '@utils/scale';

interface ReconPromptProps {
  onViewDetails: () => void;
  reconText: string;
  reconButtonText: string;
}

/**
 * ReconPrompt Component
 * Prompts user to complete recon to receive payout
 */
const ReconPrompt: React.FC<ReconPromptProps> = ({ onViewDetails, reconText, reconButtonText }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.message}>
        {reconText}
      </Text>
      <TouchableOpacity
        style={styles.button}
        onPress={onViewDetails}
        activeOpacity={0.8}
      >
        <Text style={styles.buttonText}>{reconButtonText}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = ScaledSheet.create({
  container: {
    alignItems: 'center',
  },
  message: {
    fontSize: 14,
    color: '#666666',
    textAlign: 'center',
    marginBottom: 16,
    lineHeight: 20,
  },
  button: {
    borderWidth: 1,
    borderColor: '#000000',
    borderRadius: 16,
    paddingHorizontal: 28,
    paddingVertical: 14,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#000000',
  },
});

export default ReconPrompt;


